Based on the information you have entered, you would need to
<span *ngIf="decreaseOutOfStateDirectorsTo > -1">either</span> increase the number of directors registered in
{{ settings.stateName }} to {{ increaseInstateDirectorsTo }}
<span *ngIf="decreaseOutOfStateDirectorsTo > -1">
  or decrease the number of directors registered out of state to {{ decreaseOutOfStateDirectorsTo }} to meet the registration
  requirement.</span
>
